window.addEventListener("load", (event) => {
    if($(".open-accordion").length > 1) {
        current_accordion = document.location.hash.replace('#', '')
        $("#toggles-"+ current_accordion).collapse('show');
    }
    
    $(".open-accordion").on('click', function() {
        $("[id^=toggles-]").collapse('hide');
        $("#toggles-"+ $(this).attr('data-accordion')).collapse('show');
    });
})